import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import LogoPng from "../../assets/images/resources/logo.png";
import logoImg1 from "../../assets/images/resources/logo.png";
import WOW from 'wowjs';


function Main() {

  const [showHome, setshowHome] = useState(false);
  const [showPage, setshowpage] = useState(false);
  const [showServices, setshowservices] = useState(false);
  const [showShop, setshowShop] = useState(false);
  const [showBlog, setshowBlog] = useState(false);

  const location = useLocation()
  const path = location.pathname
  const [menu, setmenu] = useState({})
  const activeMenu = () => {
    if (path === "/" || path === "/") {
      setmenu({ home: true })
    } else if (path === "/page" || path === "/page") {
      setmenu({ Page: true })
    } else if (path === "/services" || path === "/services") {
      setmenu({ services: true })
    } else if (path === "/shop" || path === "/shop") {
      setmenu({ shop: true })
    } else if (path === "/blog" || path === "/blog") {
      setmenu({ blog: true })
    }
  }


  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  useEffect(() => {
    window.scroll(0, 0)
    new WOW.WOW({
      live: false
    }).init();
    activeMenu()
  }, [path]);
  const issticky = () => {
    const scrollTop = window.scrollY;
    scrollTop >= 141 ? setIsSticky(true) : setIsSticky(false);
  }

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div>
      <header className={`main-header main-header-four ${isSticky ? "sticky-header--cloned sticky-fixed" : "sticky-header"}`}>
        <div className="container-fluid">
          <nav className="main-menu main-menu-four">
            <div className="main-menu-logo">
              <Link to="/">
                <img src={logoImg1} alt="header-logo" />
              </Link>
            </div>
            <ul className="main-menu-list main-menu-four-list">
              <li className="menu-item-children">
                <Link to="#">Home</Link>
                <i className="icon-angle-down" />
                <ul>
                  <li>
                    <Link to="/">Home One</Link>
                  </li>
                  <li>
                    <Link to="/hometwo">Home Two</Link>
                  </li>
                  <li>
                    <Link to="/homethree">Home Three</Link>
                  </li>
                  <li>
                    <Link to="/homefour">Home Four</Link>
                  </li>
                  <li>
                    <Link to="/homefive">Home Five</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-children">
                <Link to="#">Page</Link>
                <i className="icon-angle-down" />
                <ul>
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li className="menu-item-children">
                    <Link to="#">
                      Projects
                      <i className="fa fa-angle-down" />
                    </Link>
                    <ul className="sub-menu-inner">
                      <li>
                        <Link to="/projects">Popular Projects</Link>
                      </li>
                      <li>
                        <Link to="/project-details">Project Details</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/team-member">Team</Link>
                  </li>
                  <li>
                    <Link to="/package">Package</Link>
                  </li>
                  <li>
                    <Link to="/faq">FAQs</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-children">
                <Link to="#">Services</Link>
                <i className="icon-angle-down" />
                <ul>
                  <li>
                    <Link to="/service">Popular Services</Link>
                  </li>
                  <li>
                    <Link to="/services-details">SEO Services</Link>
                  </li>
                  <li>
                    <Link to="/digital-market">Digital Marketing</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-children">
                <Link to="#">Shop</Link>
                <i className="icon-angle-down" />
                <ul className="sub-menu-inner">
                  <li>
                    <Link to="/shop">Shop Page</Link>
                  </li>
                  <li>
                    <Link to="/shop-details">Product Deatils</Link>
                  </li>
                  <li>
                    <Link to="/cart">Cart</Link>
                  </li>
                  <li>
                    <Link to="/checkout">Checkout</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item-children">
                <Link to="#">Blog</Link>
                <i className="icon-angle-down" />
                <ul>
                  <li>
                    <Link to="/blog">Blog List</Link>
                  </li>
                  <li>
                    <Link to="/blog-details">Blog Details</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
            <div className="main-menu-right main-menu-four-right">
              <div className="main-menu-right-number">
                <i className="icon-call" />
                <Link to="/tel:+000(123)45688">+000 (123) 456 88</Link>
              </div>
              <Link to="/contact" className="main-btn-four thm-btn">
                Lets Talk <i className="icon-right-arrow" />
              </Link>
            </div>
            <div className="header-right-end" onClick={toggleMobileMenu}>
              <span className="line-1" />
              <span className="line-2" />
              <span className="line-3" />
            </div>
          </nav>
        </div>
      </header>
      {mobileMenuOpen &&
        <div className={`mobile-nav-wrapper ${mobileMenuOpen && "expanded"}`}>
          <div className="mobile-nav-overlay mobile-nav-toggler" />
          <div className="mobile-nav-content">
            <Link
              to="#"
              onClick={() => setMobileMenuOpen(false)}
              className="mobile-nav-close mobile-nav-toggler"
            >
              <span />
              <span />
            </Link>
            <div className="logo-box">
              <Link to="/">
                <img src={LogoPng} alt="logo" />
              </Link>
            </div>
            <div className="mobile-nav-container">
              <ul className="mobile-menu-list">
                <li className="menu-item-has-children dropdown">
                  <Link to="#" className={showHome ? "expanded" : ""}>
                    Home
                    <button onClick={() => setshowHome(!showHome)}>
                      <i className={showHome ? "fa fa-angle-left" : "fa fa-angle-down"} />
                    </button>
                  </Link>
                  <ul style={{ display: showHome ? "block" : "none" }}>
                    <li>
                      <Link to="/">Home One</Link>
                    </li>
                    <li>
                      <Link to="/hometwo">Home Two</Link>
                    </li>
                    <li>
                      <Link to="/homethree">Home Three</Link>
                    </li>
                    <li>
                      <Link to="/homefour">Home Four</Link>
                    </li>
                    <li>
                      <Link to="/homefive">Home Five</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-has-children dropdown">
                  <Link to="#" className={showPage ? "expanded" : ""}>
                    Page
                    <button onClick={() => setshowpage(!showPage)}>
                      <i className={showPage ? "fa fa-angle-left" : "fa fa-angle-down"} />
                    </button>
                  </Link>
                  <ul style={{ display: showPage ? "block" : "none" }}>
                    <li>
                      <Link to="/about">About</Link>
                    </li>
                    <li className="menu-item-has-children dropdown">
                      <Link to="#">Projects</Link>
                      <ul>
                        <li>
                          <Link to="/projects">Popular Projects</Link>
                        </li>
                        <li>
                          <Link to="/project-details">Project Details</Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link to="/team-member">Team</Link>
                    </li>
                    <li>
                      <Link to="/package">Package</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQs</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-has-children dropdown">
                  <Link to="#" className={showServices ? "expanded" : ""}>
                    Services
                    <button onClick={() => setshowservices(!showServices)}>
                      <i className={showServices ? "fa fa-angle-left" : "fa fa-angle-down"} />
                    </button>
                  </Link>
                  <ul style={{ display: showServices ? "block" : "none" }}>
                    <li>
                      <Link to="/service">Popular Services</Link>
                    </li>
                    <li>
                      <Link to="/services-details">SEO Services</Link>
                    </li>
                    <li>
                      <Link to="/digital-market">Digital Marketing</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-has-children dropdown">
                  <Link to="#" className={showShop ? "expanded" : ""}>
                    Shop
                    <button onClick={() => setshowShop(!showShop)}>
                      <i
                        className={showShop ? "fa fa-angle-left" : "fa fa-angle-down"}
                      />
                    </button>
                  </Link>
                  <ul style={{ display: showShop ? "block" : "none" }}>
                    <li>
                      <Link to="/shop">Shop Page</Link>
                    </li>
                    <li>
                      <Link to="/shop-details">Product Deatils</Link>
                    </li>
                    <li>
                      <Link to="/cart">Cart</Link>
                    </li>
                    <li>
                      <Link to="/checkout">Checkout</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-item-has-children dropdown">
                  <Link to="#" className={showBlog ? "expanded" : ""}>
                    Blog
                    <button onClick={() => setshowBlog(!showBlog)}>
                      <i className={showBlog ? "fa fa-angle-left" : "fa fa-angle-down"} />
                    </button>
                  </Link>
                  <ul style={{ display: showBlog ? "block" : "none" }}>
                    <li>
                      <Link to="/blog">Blog List</Link>
                    </li>
                    <li>
                      <Link to="/blog-details">Blog Details</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
            <ul className="mobile-nav-contact list-unstyled">
              <li>
                <i className="fa fa-phone" />
                <Link to="/tel:+8898006802">+91 6353967672</Link>
              </li>
              <li>
                <i className="fa fa-envelope" />
                <Link to="/mailto:info@zoso.com">info@zoso.com</Link>
              </li>
            </ul>
            <ul className="mobile-nav-social">
              <li>
                <Link to="#">
                  <i className="icon-facebook-f" />
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="icon-twitter" />
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="icon-instagram" />
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="icon-linkedin-in" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      }
    </div>

  );
}

export default Main;
